import { ResourcesConfig } from 'aws-amplify';

export const baseAuthConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: '',
      userPoolClientId: '',
      loginWith: {
        username: true,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
};

export default baseAuthConfig;
